<template>
  <div class="content">
    <md-card style="margin-bottom: 20px; margin-top: 10px">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-field>
            <label>Recherche multi-critères</label>
            <md-input v-on:keyup.enter="search" v-model="query"></md-input>
            <span class="md-helper-text">Nom, RPPS, FINESS, raison sociale, email, téléphone, N° éditeur, N° ASP</span>
          </md-field>
        </div>
        <div class="md-layout-item" style="margin-top: 7px">
          <v-select :items="filterTypeOptions" v-model="filterType" item-text="text" item-value="value" label="Type" @change="search"></v-select>
        </div>
        <div class="md-layout-item" style="margin-top: 7px">
          <v-select :items="partyTypeOptions" v-model="partyType" item-text="text" item-value="value" label="Type structure" @change="search"></v-select>
        </div>
        <div class="md-layout-item" style="margin-top: 7px">
          <v-select :items="sortOptions" v-model="sortBy" label="Trier par"></v-select>
        </div>
        <div class="md-layout-item" style="margin-top: 7px">
          <v-select :items="['Décroissant', 'Croissant']" v-model="sortOrder" label="Tri"></v-select>
        </div>
      </div>
      <md-button class="md-prokov researcheButton" @click="search()">Rechercher</md-button>
      <button class="diagCloseButton" @click="clearSearch()">
        <md-icon>delete</md-icon>
      </button>
      <div v-if="searchTruncated" style="font-size: 12px; color: #c62828; margin-top: 4px">
        Plus de 200 résultats sur la recherche - affinez votre saisie pour ne rien manquer.
      </div>
    </md-card>

    <div style="font-size: 13px; color: #888; margin-bottom: 8px">
      {{ totalCount }} bons de commande V1
    </div>

    <div style="width: 100%" class="md-layout">
      <md-table v-if="rows && rows.length" v-model="rows">
        <md-table-row slot="md-table-row" slot-scope="{ item }">

          <md-table-cell md-label="Résident" v-if="item.resident">
            {{ item.resident.prénom }} {{ item.resident.nom }}
          </md-table-cell>

          <md-table-cell md-label="RPPS">
            <template v-if="item.msp">
              <span :title="mspTooltip(item.msp)">F - {{ item.msp.FINESS }}</span>
              <div v-if="item.msp.raisonSociale" style="font-size: 11px; color: #666">
                {{ item.msp.raisonSociale }}
              </div>
            </template>
            <template v-else-if="item.resident">R - {{ item.resident.RPPS }}</template>
          </md-table-cell>

          <md-table-cell md-label="N° Éditeur">{{ item.numeroEditeur }}</md-table-cell>

          <md-table-cell md-label="Montant">{{ item.montantSegurHT }} €</md-table-cell>

          <md-table-cell md-label="Date">
            {{ getDate(item.dateSignatureCommande || item.createdAt) }}
          </md-table-cell>

          <md-table-cell md-label="État">
            <v-chip x-small :color="item.state === 'ON' ? 'green' : item.state === 'ENABLE' ? 'orange' : 'grey'" dark>
              {{ item.state === 'ON' ? 'Terminé' : item.state === 'ENABLE' ? 'Signé' : item.state }}
            </v-chip>
          </md-table-cell>

          <md-table-cell md-label="N° ASP">{{ item.numeroASP || '-' }}</md-table-cell>

          <md-table-cell md-label="VA">
            <v-chip v-if="item.files && item.files.vaPDF" color="green" x-small dark>Oui</v-chip>
            <v-chip v-else color="red" x-small dark>Non</v-chip>
          </md-table-cell>

          <md-table-cell md-label="">
            <v-btn class="mx-2" icon small color="teal" @click="selectedItem = item; dialog = true">
              <v-icon dark>mdi-format-list-bulleted-square</v-icon>
            </v-btn>
          </md-table-cell>

        </md-table-row>
      </md-table>
      <div v-else style="padding: 20px; text-align: center; color: #999">
        Aucun bon de commande V1
      </div>
    </div>

    <div class="text-center" style="margin-top: 10px">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <!-- Détail -->
    <v-dialog v-model="dialog" width="600">
      <v-card v-if="selectedItem">
        <v-card-title class="text-h5 grey lighten-2">
          {{ selectedItem.resident ? selectedItem.resident.prénom + ' ' + selectedItem.resident.nom : 'BDC V1' }}
        </v-card-title>
        <v-card-text>
          <div style="color: blue; margin-top: 10px">
            N° éditeur : {{ selectedItem.numeroEditeur }}<br />
            N° ASP : {{ selectedItem.numeroASP || '-' }}<br />
            Montant HT : {{ selectedItem.montantSegurHT }} €<br />
            État : {{ selectedItem.state }}<br />
            <br />
            <template v-if="selectedItem.resident">
              RPPS : {{ selectedItem.resident.RPPS }}<br />
              Email : {{ selectedItem.resident.email }}<br />
              Tél : {{ selectedItem.resident.phone }}<br />
            </template>
            <template v-if="selectedItem.msp">
              FINESS : {{ selectedItem.msp.FINESS }}<br />
              <template v-if="selectedItem.msp.FINESSGEO">
                FINESS GEO : {{ selectedItem.msp.FINESSGEO }}<br />
              </template>
              <template v-if="selectedItem.msp.raisonSociale">
                Raison sociale : {{ selectedItem.msp.raisonSociale }}<br />
              </template>
              <template v-if="selectedItem.msp.partnerRef">
                Réf. interne : {{ selectedItem.msp.partnerRef }}<br />
              </template>
            </template>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import server from "@/store/server";

const API_BASE = server.url;
const PAGE_SIZE = 50;

export default {
  name: "SegurArchives",
  data() {
    return {
      rows: [],
      totalCount: 0,
      query: "",
      sortBy: "N° Éditeur",
      sortOptions: ["N° Éditeur", "N° ASP", "Montant", "Date"],
      sortOrder: "Décroissant",
      filterType: "archivesV1",
      filterTypeOptions: [
        { text: "Tous les V1", value: "archivesV1" },
        { text: "V1 gratuits uniquement", value: "v1Free" },
      ],
      partyType: "all",
      partyTypeOptions: [
        { text: "Tous", value: "all" },
        { text: "MSP uniquement", value: "msp" },
        { text: "Libéral uniquement", value: "liberal" },
      ],
      searchTruncated: false,
      page: 1,
      dialog: false,
      selectedItem: null,
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.totalCount / PAGE_SIZE) || 1;
    },
  },
  watch: {
    page() {
      this.fetchArchives();
    },
  },
  created() {
    this.fetchArchives();
  },
  methods: {
    async fetchArchives() {
      try {
        const res = await axios.post(
          `${API_BASE}/segur/v2/orderforms`,
          {
            tab: this.filterType,
            search: this.query,
            sortBy: { "N° Éditeur": "numeroEditeur", "N° ASP": "numeroASP", "Montant": "montant", "Date": "date" }[this.sortBy] || "numeroEditeur",
            sortOrder: this.sortOrder === "Croissant" ? "ASC" : "DESC",
            offset: (this.page - 1) * PAGE_SIZE,
            limit: PAGE_SIZE,
            partyType: this.partyType,
          },
          { headers: server.getHeader() }
        );
        if (res.data && res.data.success) {
          this.rows = res.data.data.rows;
          this.totalCount = res.data.data.count;
          this.searchTruncated = !!res.data.data.searchTruncated;
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("[SegurArchives] Erreur:", err.message);
      }
    },
    search() {
      this.page = 1;
      this.fetchArchives();
    },
    clearSearch() {
      this.query = "";
      this.partyType = "all";
      this.page = 1;
      this.fetchArchives();
    },
    mspTooltip(msp) {
      if (!msp) return "";
      const parts = [];
      if (msp.FINESSGEO) parts.push("FINESS GEO : " + msp.FINESSGEO);
      if (msp.raisonSociale) parts.push(msp.raisonSociale);
      if (msp.partnerRef) parts.push("Réf : " + msp.partnerRef);
      return parts.join(" - ");
    },
    getDate(d) {
      if (!d) return "";
      const date = new Date(d);
      return (
        ("0" + date.getDate()).slice(-2) + "/" +
        ("0" + (date.getMonth() + 1)).slice(-2) + "/" +
        date.getFullYear()
      );
    },
  },
};
</script>

<style scoped>
.content { max-width: 100%; padding: 0; }
.md-table { width: 100%; }
.md-table .md-table-cell { white-space: nowrap; font-size: 13px; padding: 4px 8px; }
</style>
